import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-6">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h2 className="text-xl font-bold mb-4">PCAB Reporting System</h2>
            <p>A centralized platform for reporting contractor activities across the Philippines.</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
              <li><Link to="/report" className="hover:text-gray-300">Submit a Report</Link></li>
              <li><Link to="/login" className="hover:text-gray-300">Staff Login</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <address className="not-italic">
              <p>Philippine Contractors Accreditation Board</p>
              <p>Manila, Philippines</p>
              <p className="mt-2">Email: contact@pcab-reporting.gov.ph</p>
              <p>Phone: (02) 8-XXX-XXXX</p>
            </address>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p>&copy; {new Date().getFullYear()} National Contractor Reporting System. All rights reserved.</p>
          <p className="text-sm mt-2">In compliance with the Data Privacy Act of 2012</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
